import React from 'react'
import Navbar from '../header/Navbar'
import Footer from '../footer/Footer'
import HeroImg2 from '../additional/HeroImg2'
import ContactForm from '../additional/ContactForm'
import FAQ from '../additional/FAQ'

const Contact = () => {
  return (
    <div>
      <Navbar/>
      <HeroImg2 heading="Contact" text="let's have a chat"/>
      <ContactForm/>
      <FAQ/>
      <Footer/>
    </div>
  )
}

export default Contact